module.exports = __webpack_public_path__ + "media/img/logo-transparent-lg-dark-911dac719e8f2c901203fb7fb9e5b427.png";